import type { Color } from "@msuite/utils/colors";
import { StatusIndicator } from "../status-indicator";

/** Props Interface */
interface SegmentedMeterLegendItemProps {
	label: string;
	color: Color;
	/** The share in percent. */
	percent: number;
}

export function SegmentedMeterLegendItem({ label, color, percent }: SegmentedMeterLegendItemProps) {
	/** Render */
	// One size for the whole entry — the name set off by weight, the share by colour — so a legend
	// beneath any card reads the same, whatever text size the card itself inherits.
	return (
		<div className="h-stack items-center gap-1.5 min-w-0 text-xs leading-none">
			<StatusIndicator
				color={color}
				size="sm"
			/>
			<span className="font-semibold truncate">{label}</span>
			<span className="opacity-60 tabular-nums whitespace-nowrap">
				{percent.toLocaleString("de-DE", { maximumFractionDigits: 1 })} %
			</span>
		</div>
	);
}
